"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const utils_1 = require("./utils");
// The number of child DOM nodes needed for each animation type
const typeToCountersMap = {
    'chasing-dots': 2,
    circle: 12,
    'cube-grid': 9,
    'double-bounce': 2,
    'fading-circle': 12,
    'folding-cube': 4,
    pulse: 0,
    'rotating-plane': 0,
    'three-bounce': 3,
    'wandering-cubes': 2,
    wave: 5
};
function IndeterminateSpinner({ color = 'blue', size = 80, type = 'circle' }) {
    const counters = typeToCountersMap[type];
    const className = `bah-uswds-spinner--${type}`;
    const [innerStyle, setInnerStyle] = (0, react_1.useState)({});
    const [childStyle, setChildStyle] = (0, react_1.useState)({});
    (0, react_1.useEffect)(() => {
        (0, utils_1.handleSpecialCases)(size, type, setInnerStyle, setChildStyle);
    }, [size, type]);
    const counterNodes = [];
    for (let i = 1; i <= counters; i++) {
        counterNodes.push((0, jsx_runtime_1.jsx)("div", { className: `${className}${i} bah-uswds-spinner--child ${color}`, style: childStyle }, `${className}${i}`));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { "aria-live": "assertive", className: "bah-uswds-spinner", role: "alert", children: [(0, jsx_runtime_1.jsx)("div", { className: "bah-uswds-spinner--wrapper", style: { width: size, height: size }, children: (0, jsx_runtime_1.jsx)("div", { className: `${className} ${color}`, style: innerStyle, children: counterNodes }) }), (0, jsx_runtime_1.jsx)("div", { className: "bah-uswds-loading--sr-text", children: "Content is loading..." })] }));
}
exports.default = IndeterminateSpinner;
